import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '@constants/colors';
import { Icon } from '@mui';
import './show-more.scss';

const ShowMore = ({ list, max, onClick, showAll }) => {
  if (list && list.length > max) {
    return (
      <div onClick={onClick} role="presentation" styleName="show-more-container">
        <Icon color={colors.opacity.black0_6} style={{ paddingRight: '12px', width: '24px'}} role="img">more_horiz</Icon>
        <div>{!showAll ? 'SHOW MORE' : 'SHOW LESS'}</div>
      </div>
    );
  }
  return null;
};

ShowMore.propTypes = {
  list: PropTypes.array,
  max: PropTypes.number,
  onClick: PropTypes.func,
  showAll: PropTypes.bool
};

export default ShowMore;
